/*
 * File: 客户经理看板-收入预测-预测系数
 */
<template>
    <div class="revenue-factor">
        <Paper class="revenue-factor-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <search-box
                        ref="searchBox"
                        :search-key="config.name"
                        :fields="config.searchFields"
                        :showResetBtn="true"
                        @elementChange="searchChange"
                        @search-change="factorList.searchList"
                    />
                </template>
                <template slot="header-button">
                    <lotsButton
                        v-has="authorityCode.add"
                        type="primary"
                        size="mini"
                        title="新增"
                        icon="el-icon-plus"
                        @click="handleAdd">新增
                    </lotsButton>
                    <lotsButton
                        v-has="authorityCode.export"
                        type="primary"
                        size="mini"
                        title="导出"
                        icon="el-icon-download"
                        @click="handleExport">导出
                    </lotsButton>
                    <lotsButton
                        type="primary"
                        size="mini"
                        title="刷新"
                        @click="factorList.getList()"
                        plain>
                        <span class="icon iconfont icon-refresh"></span>
                    </lotsButton>
                    <el-tooltip effect="dark" content="列配置" placement="bottom">
                        <el-button icon="iconfont icon-list_install" type="primary" size="mini" @click="handleColumnConfig" plain />
                    </el-tooltip>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <edit-table-box
                        ref="editTableBox"
                        v-loading="factorList.tableLoading"
                        :key="rendertable"
                        :index="config.index"
                        :selection="config.selection"
                        :columns="config.columns"
                        :height="tableHeight"
                        :tableData="factorList.totalData"
                        :actions="config.actions || []"
                        :rowEdit="config.rowEdit"
                        :allowRowClick="!config.getAuthRole()"
                        :allowRowClickFunc="(row) => config.rowEnableEditFun(row, dictDatas)"
                        :editDisableRule="(row) => !config.rowEnableEditFun(row, dictDatas)"
                        @selection-change="factorList.handleSelectedRow"
                        @btn-event="handleActive"
                    >
                        <template #col-append="{item, row}">
                            <!-- 系数类型、状态 -->
                            <span v-if="['coefType', 'coefStatus'].includes(item.prop)">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                            <!-- 分类 -->
                            <span v-if="item.prop === 'coefCategory'">{{ formatData(row[item.prop], row) }}</span>
                            <!-- 1-12月系数 -->
                            <span v-if="['coefForecast1m', 'coefForecast2m', 'coefForecast3m', 'coefForecast4m',
                                        'coefForecast5m', 'coefForecast6m', 'coefForecast7m', 'coefForecast8m',
                                        'coefForecast9m', 'coefForecast10m', 'coefForecast11m', 'coefForecast12m'
                                ].includes(item.prop)">{{ processString(row[item.prop] || 0) + '%' }}</span>
                        </template>
                        <template #edit-col-append="{ item, row }">
                            <!-- 系数类型、分类、年份，仅新增时允许编辑，保存后只读不允许修改 -->
                            <el-select v-if="item.prop === 'coefType' && !row.id" v-model="row[item.prop]" @change="(val) => handleChangeRow({ prop: item.prop, val, row })">
                                <el-option
                                    v-for="it in handleDictionaryDataString(dictDatas[item.optionsKey])"
                                    :key="it.value"
                                    :label="it.label"
                                    :value="it.value"
                                />
                            </el-select>
                            <el-select
                                v-if="item.prop === 'coefCategory' && !row.id && +row.coefType === 0"
                                v-model="row[item.prop]"
                                @change="(val) => handleChangeRow({ prop: item.prop, val, row })"
                            >
                                <el-option
                                    v-for="it in coefCategoryOptions"
                                    :key="it.value"
                                    :label="it.label"
                                    :value="it.value"
                                />
                            </el-select>
                            <el-cascader
                                v-if="item.prop === 'coefCategory' && !row.id && +row.coefType === 1"
                                size="mini"
                                v-model="row[item.prop]"
                                :options="coefCategoryOptions"
                                :props="{ label: 'industryName', value: 'industryCode' }"
                                :show-all-levels="false"
                                :filterable="true"
                                @change="(val) => handleChangeRow({ prop: item.prop, val, row })"
                            />
                            <el-date-picker
                                v-if="item.prop === 'coefYear' && !row.id"
                                v-model="row[item.prop]"
                                type="year"
                                format="yyyy"
                                valueFormat="yyyy"
                            />
                            <span v-if="item.prop === 'coefType' && row.id">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                            <span v-if="item.prop === 'coefCategory' && row.id">{{ formatData(row[item.prop], row) }}</span>
                            <span v-if="item.prop === 'coefYear' && row.id">{{ row[item.prop] }}</span>
                            <span v-if="item.prop === 'coefStatus'">{{ formatDictCodeToName(row[item.prop], dictDatas[item.optionsKey]) }}</span>
                        </template>
                    </edit-table-box>

                    <!-- 表格列配置弹框 -->
                    <column-config
                        ref="columnConfigRef"
                        :pageID="config.name"
                        :initColumns="config.columns"
                        @header-change="config.columns = $event"
                    />
                </template>
                <template slot="footer">
                    <lots-pagination
                        @size-change="factorList.sizeChange"
                        :current-page.sync="factorList.pageNo"
                        @current-change="factorList.pageChange"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="factorList.pageTotal" >
                    </lots-pagination>
                </template>
            </list-layout-paper>
        </Paper>
    </div>
</template>

<script>
import { ref, reactive, onMounted, onActivated } from '@vue/composition-api';
import { Message } from 'element-ui';
import utils from '@/components/utils/common.js';
import store from '@/store';
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { handleDictionaryDataString, formatDictCodeToName } from '@/modules/mdm/utils.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import { processString } from '@/utils/format.js';
import _ from 'lodash';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import Paper from '@/components/core/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import editTableBox from '@/components/lots/editTableBox/Index';
import columnConfig from '@/components/lots/columnConfig/Index';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import { getIndustryTree } from '@mdm/api/contractManage/contractRegistration.js';
import { getRevenueFactorPage, revenueFactorExport, revenueFactorSave } from '@mdm/api/customer/revenueFactor.js';
import { config as configStatic } from './config';

export default {
    name: 'revenueFactor',
    components: {
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        editTableBox,
        lotsPagination,
        columnConfig
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.revenueFactor);
        const { user } = store.getters;
        const config = reactive(configStatic);
        const dictDatas = ref({});
        const industryData = ref([]); // 行业大类与细分行业级联数据
        const coefCategoryOptions = ref([]); // 分类下拉项
        const rendertable = ref(1);

        class AccountListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList (res) {
                if (+res.code === 0) {
                    this.totalData.value = res.data.list.map(v => {
                        return {
                            edit: -3,
                            allowEdit: true,
                            ...v,
                            coefType: v.coefType?.toString(),
                            coefCategory: v.coefCategory?.toString(),
                            coefStatus: v.coefStatus?.toString()
                        }; ;
                    });
                    this.pageTotal.value = res.data.totalCount;
                }
                setupContext.root.$nextTick(() => {
                    setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
                });
            };
        }
        const factorList = new AccountListClass({
            Api: {
                listApi: getRevenueFactorPage // 查询接口
            }
        });
        // 查询参数转换
        const searchDataFormat = (condition = {}, params = {}) => {
            if (condition.coefCategory && Array.isArray(condition.coefCategory)) {
                condition.coefCategory = condition.coefCategory[1];
            }
            if (condition.createTimeFixed) {
                condition.startTime = utils.formatDateTime(condition.createTimeFixed[0]);
                condition.endTime = utils.formatDateTime(condition.createTimeFixed[1]);
                Reflect.deleteProperty(condition, 'createTimeFixed');
            }

            const newParams = { ...condition, ...params, userCode: user.userCode };
            Object.keys(newParams).forEach(v => {
                if (newParams[v] === undefined || newParams[v] === null || newParams[v] === '') {
                    delete newParams[v];
                }
            });
            return newParams;
        };
        // 查询条件发生变化时回调
        const searchChange = ({ column, searchData }) => {
            if (column.value === 'coefType') {
                searchData.coefCategory = '';
                const field = config.searchFields.find((v) => v.value === 'coefCategory');
                field.type = 'select';
                if (searchData.coefType) {
                    if (+searchData.coefType === 1) {
                        field.type = 'cascader'; // 系数类型为行业，分类为行业大类级联
                    }
                    field.options = setCoefCategoryOptions(searchData.coefType);
                } else {
                    field.options = [];
                }
            }
        };
        // 设置分类的下拉项
        const setCoefCategoryOptions = (index) => {
            // 当系数类型为专业公司时，提供业务场景大类的下拉项；当系数类型为行业时，提供细分行业的下拉项；
            const result = [];

            // 转换业务场景大类字典
            const businessDict = dictDatas.value['BUSINESS_CATEGORY_MAPPING'];
            const businessOption = [];
            if (businessDict) {
                Object.keys(businessDict).forEach((key) => {
                    const item = JSON.parse(businessDict[key]);
                    businessOption.push({ label: key, value: key, ...item });
                });
            }
            result.push(businessOption);

            // 行业大类与细分行业级联数据
            result.push(industryData.value);

            return result[index];
        };
        // 大类与分类显示转换
        const formatData = (val, row) => {
            const options = setCoefCategoryOptions(row.coefType) || [];
            let coefCategory = '';
            if (+row.coefType === 1) {
                // 系数类型为行业
                const result = options.find(v => {
                    const item = v.children?.find(c => c.industryCode === val);
                    if (item) {
                        v.matchIndustry = item;
                        return true;
                    }
                    return false;
                });
                row.category = result?.industryName;
                coefCategory = result?.matchIndustry?.industryName;
            } else {
                // 系数类型为专业公司
                const result = options.find((v) => v.value === val);
                row.category = result?.name;
                coefCategory = result?.label;
            }
            return coefCategory;
        };
        // 刷新表格
        const handleRendertable = () => {
            rendertable.value++;
        };
        // 新增
        const handleAdd = () => {
            factorList.totalData.value.unshift({
                edit: 2,
                allowEdit: true,
                coefStatus: '0' // 启用
            });
            const timer = setTimeout(() => { // 解决表格错位
                setupContext.refs.editTableBox.$refs.moduleTable.doLayout();
            });
            timer && clearTimeout(timer);
        };
        // 导出
        const handleExport = async () => {
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = factorList.searchModel;
            const newData = _.cloneDeep(value); // 解决搜索参数被清空的问题
            const excelTitleList = otherUtils.sortColumnsByFixed(config.columns)?.map((item) => ({
                name: item.name,
                property: item.property
            }));
            const params = {
                ...searchDataFormat(newData),
                deleteFlag: 0,
                excelTitleList
            };
            revenueFactorExport(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => {});
        };
        // 列配置
        const handleColumnConfig = () => {
            setupContext.refs.columnConfigRef.show(true);
        };
        // 表格内表单元素发生变化时回调
        const handleChangeRow = async ({ prop, val, row }) => {
            // 系数类型
            if (prop === 'coefType') {
                row.category = ''; // 大类
                row.coefCategory = ''; // 分类
                if (val) {
                    coefCategoryOptions.value = setCoefCategoryOptions(row.coefType);
                } else {
                    coefCategoryOptions.value = [];
                }
            }
            // 分类
            if (prop === 'coefCategory') {
                row.category = '';
                if (+row.coefType === 1) {
                    row.category = coefCategoryOptions.value.find((v) => v.industryCode === val[0])?.industryName;
                } else {
                    row.category = coefCategoryOptions.value.find((v) => v.value === val)?.name;
                }
                handleRendertable();
            }
        };
        // 操作项
        const handleActive = (row, event) => {
            // 取消
            if (event === 'cancel') {
                handleRendertable();
            }
            // 保存
            if (event === 'save') {
                handleSave(row);
            }
            // 启用
            if (event === 'enable') {
                handleEnable(row);
            }
            // 停用
            if (event === 'disable') {
                handleDisable(row);
            }
        };
        // 保存
        const handleSave = (row) => {
            let result = 0;
            const number = 12;
            const obj = {};
            for (let i = 1; i <= number; i++) {
                const cast = processString(row[`coefForecast${i}m`] || 0);
                obj[[`coefForecast${i}m`]] = cast;
                result += cast;
            }
            const newResult = result.toFixed(6);
            const total = 100;
            if (newResult !== total.toFixed(6)) {
                Message.warning(`系数汇总必须等于100%，目前系数汇总为${newResult}%，偏差${(100 - newResult).toFixed(6)}%`);
                return false;
            }

            const params = {
                ...row,
                ...obj,
                coefCategory: Array.isArray(row.coefCategory) ? row.coefCategory[1] : row.coefCategory
            };
            revenueFactorSave(params).then(res => {
                if (+res.code === 0) {
                    Message.success('保存成功');
                    factorList.getList();
                }
            }).finally(() => {});
        };
        // 启用
        const handleEnable = (row) => {
            revenueFactorSave({ ...row, coefStatus: '0' }).then(res => {
                if (+res.code === 0) {
                    Message.success('启用成功');
                    factorList.getList();
                }
            }).finally(() => {});
        };
        // 停用
        const handleDisable = (row) => {
            revenueFactorSave({ ...row, coefStatus: '1' }).then(res => {
                if (+res.code === 0) {
                    Message.success('停用成功');
                    factorList.getList();
                }
            }).finally(() => {});
        };

        onActivated(() => {
            setupContext.refs.editTableBox.$refs.moduleTable.doLayout(); // 解决表格错位
        });
        onMounted(async () => {
            setupContext.refs.searchBox.submitSearch();
            const { data } = await getDictDataApi({
                dictCodes: 'CRM_COEFFICIENT_TYPE,CRM_COEFFICIENT_STATUS,BUSINESS_CATEGORY_MAPPING,LCRM_PRIVILEGED_ROLE_LIST'
            });
            dictDatas.value = data || {};

            // 获取行业大类与细分行业级联数据
            const { data: treeData } = await getIndustryTree({ industryStatus: 1 }); // 0-停用、1-启用
            industryData.value = treeData || [];
        });
        return {
            factorList,
            config,
            authorityCode,
            dictDatas,
            coefCategoryOptions,
            rendertable,
            searchChange,
            processString,
            formatData,
            formatDictCodeToName,
            handleDictionaryDataString,
            handleAdd,
            handleExport,
            handleColumnConfig,
            handleChangeRow,
            handleActive
        };
    }
};
</script>

<style lang="less" >
.revenue-factor {
    width: 100%;
    .revenue-factor-paper {
        height: 100%;
    }
    .header-button {
        margin-left: 10px;
    }
    .search-box .el-select .el-input input {
        height: 28px!important;
    }
    .list-layout-wrapper {
        height: 100%;
    }

    .list-layout .list-header .el-input {
        margin-left: 0;
    }
    .flex-layout .list-main {
        overflow: auto;
    }

    .flex-layout .table {
        overflow-y: auto;
    }

    .layout-content.revenue-factor-paper {
        padding: 0px 0px 0px;
    }
}
</style>
